<template>
    <div>
        <v-dialog v-model="dialogStatusModel" kind="modal" status="default" class="application-dialog" @close="cancel">
            <div slot="title">
                信息修改申请表
            </div>
            <div slot="caption">
                通过提交申请表，修改企业管理员信息
            </div>
            <div>
                <div class="application-title">
                    <div class="application-title-name">
                        企业全称：<span>{{ info.company }}</span>
                    </div>
                    <div>企业主号：<span>{{ info.corp_uin }}</span></div>
                </div>
                <div>
                    <v-steps :titles="stepTitles" :index="currentStep" />
                </div>
                <editContact v-show="currentStep === 1" :contact="info" :new-q-q="newQQ" />
                <uploadData v-show="currentStep === 2" ref="uploadData" :new-q-q="newQQ" :new-phone="newPhone"
                    :contact="info" />
            </div>
        </v-dialog>
        <qqLogin v-if="currentStep === 1 && showQQLogin" ref="qqLogin" :main="info" />
    </div>
</template>

<script>
import uploadData from './uploadData.vue';
import editContact from './editContact.vue';
import qqLogin from './qqLogin.vue';
export default {
    components: {
        uploadData,
        editContact,
        qqLogin,
    },
    props: {
        dialogStatus: {
            type: Boolean,
            default: false,
        },
        info: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            dialogStatusModel: false,
            stepTitles: ['修改联系方式', '上传资料'],
            currentStep: 1,
            newQQ: '',
            newPhone: '',
            showQQLogin: false,
            selected: this.info.defaultSelect,
        };
    },
    watch: {
        dialogStatus: {
            handler(newVal) {
                this.dialogStatusModel = newVal;
            },
            deep: true,
        },
    },
    methods: {
        /**
         * 刷新QQ登录框的展现状态，因为登录框内部的iframe在登录成功之后会进行页面跳转，导致下一次打开弹框的时候展示空白，所以需要重置组件
         * @param {boolean} showQQLogin 展现状态
         * @return {void}
         */
        getShowQQLogin() {
            this.showQQLogin = false;
            this.$nextTick(() => {
                this.showQQLogin = true;
            });
        },
        /**
         * 记录一下新的QQ号
         * @param {number} newQQ QQ号
         * @return {void}
         */
        getNewQQFrom(newQQ) {
            this.newQQ = newQQ;
        },
        /**
         * 记录一下新的手机号
         * @param {number} newPhone QQ号
         * @return {void}
         */
         getNewPhoneFrom(newPhone) {
            this.newPhone = newPhone;
        },
        /**
         * 跳转到QQ登录界面
         * @param {Boolean} qq登录的开关
         * @return {void}
         */
        clickAddNewAdminQQ(status) {
            this.$refs.qqLogin.qqLoginFrameSwitch(status);
            // this.isOpenQQLoginFrame = status;
        },
        /**
         * 上一步
         * @return {void}
         */
         clickPreviousStep() {
            this.currentStep = 1;
        },

        /**
         * 下一步
         * @return {void}
         */
        clickNextStep() {
            this.currentStep = 2;
        },
        /**
         * 更新选中
         * @param {number} type - 选中项
         * @param {boolean} bool - 选中|取消
         */
        updateSelectedItems(type, bool) {
            if (bool) {
                if (!this.selected.includes(type)) this.selected.push(type);
            } else {
                this.selected.splice(this.selected.findIndex(item => item === type), 1);
            }
        },
        cancel(force = false) {
            const { uploadData } = this.$refs;
            if (!force && uploadData && uploadData.submitLoading) {
                this.dialogStatusModel = true;
                return;
            }
            if (uploadData) {
                uploadData.invalidateOcrRequests();
            }
            this.$emit('cancel');
        },
    },
};
</script>

<style lang="less" scoped>
.application-dialog {
    /deep/ .v-page-header {
        margin-bottom: 2px;
    }
}

.application-title {
    display: flex;
    text-align: left;

    &-name {
        max-width: 303px;
        margin-right: 24px;
        margin-bottom: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
}
</style>
<style></style>
